var React = require('react');
var { useMemo } = require('react');
var { Link, useLocation } = require('react-router-dom');
var { connect } = require('react-redux');
const { HOME_PATH } = require('./viewPaths');
var { useTranslation } = require('react-i18next');

function NavigationLine({ selected_distribution }) {
  const { t } = useTranslation();
  const location = useLocation();
  const currentPath = location.pathname;

  // Compute sub_path_name based on current path
  const subPathName = useMemo(() => {
    const pathParts = currentPath.split('/');

    if (pathParts.length > 1) {
      if (pathParts[1] === '') {
        return 'My Fields';
      } else {
        const match = pathParts[1].match(/[A-Z][a-z]+|[0-9]+/g);
        return match ? match.join(' ') : pathParts[1];
      }
    }
    return '';
  }, [currentPath]);

  const isFarmingUnitsPage = currentPath.includes('FarmingUnitsManagement');

  return (
    <div>
      <Link to={HOME_PATH}>{t('home')}</Link>
      {isFarmingUnitsPage && selected_distribution && (
        <>
          {' -> '}
          <Link to='/DistributionUnitsManagement'>
            {selected_distribution.name}
          </Link>
        </>
      )}
      {!isFarmingUnitsPage && (
        <>
          {' -> '}
          {subPathName}
        </>
      )}
    </div>
  );
}

const mapStateToProps = function (state) {
  return {
    selected_distribution:
      state.distribution_data.selected_entities.distribution,
  };
};

module.exports = connect(mapStateToProps)(NavigationLine);
